export const isMetafieldValueTrue = (value) => typeof value === 'string' && value.trim().toLowerCase() === 'true';
